var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{style:({color: 'green'}),attrs:{"size":"mini"},on:{"click":_vm.handleView}},[_vm._v("Edit")])}
var staticRenderFns = []

export { render, staticRenderFns }